import { observer } from "mobx-react";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Order } from "types/order";
import { getTitle } from "utils";
import { OrderList } from "./components/OrderList";
import { OrderDetailModal } from "./OrderDetailModal";

export const OrderPage = observer(({ title = "" }: { title?: string }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [reloadKey, setReloadKey] = useState(0);
  const orderId = Number(searchParams.get("orderId")) || 0;

  useEffect(() => {
    document.title = getTitle(title);
  }, [title]);

  const openOrder = useCallback(
    (order: Order) => {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        next.set("orderId", String(order.id));
        return next;
      });
    },
    [setSearchParams],
  );

  const closeOrder = useCallback(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete("orderId");
        return next;
      },
      { replace: true },
    );
  }, [setSearchParams]);

  const handleChanged = useCallback(() => {
    setReloadKey((value) => value + 1);
  }, []);

  return (
    <>
      <OrderList reloadKey={reloadKey} onOpen={openOrder} />
      <OrderDetailModal orderId={orderId} open={orderId > 0} onClose={closeOrder} onChanged={handleChanged} />
    </>
  );
});
